import React, {FC, ReactNode} from 'react';
import { JsxExpression } from 'typescript';

interface Props {
    orientation?: string;
    hAlign?: string;
    vAlign?: string;
    style?: object;
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
    children?: ReactNode;
}

export const FlexContainer: FC<Props> = ({
    orientation = 'row',
    hAlign = 'center',
    vAlign = 'center',
    className = '',
    onClick = () => undefined,
    style = {},
    children,
}) => {

    const mainStyle: object = {
        display: 'flex',
        flexDirection: orientation,
        justifyContent: orientation === 'row' ? hAlign : vAlign,
        alignItems: orientation === 'row' ? vAlign : hAlign,
    }

    const fullStyle: object = {...mainStyle, ...style};

    return (
        <div 
            style={fullStyle} 
            className={className}
            onClick={onClick}
        >
            {children}
        </div>
    )
}

